import React, { useEffect, useState } from 'react'
import Select from "../../../modules/react-select-plus";
import "react-select-plus/dist/react-select-plus.css";
import { fetchProviderData } from '../../../store/actions';

function ProviderTypes({ providerType,setProviderType }) {
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
      fetchProviderData('', setOptions, setIsLoading);
    },[]);
  
    const handleInputChange = (inputValue) => {
      // if (!inputValue) {
      //   setOptions([]);
      //   return;
      // }
      fetchProviderData(inputValue, setOptions, setIsLoading);
    };
  
    const handleChange = (selectedOption) => {
      debugger
      console.log("Selected:", selectedOption);
      setProviderType(selectedOption.value);
    };
  return (
    <div className='input-div-1 clinic-profile-signup' style={{ margin: '0px 0px'}}>
      {console.log(options)}
      <Select
        onInputChange={handleInputChange}
        onChange={handleChange}
        options={options}
        isLoading={isLoading}
        placeholder="Search provider number"
        isClearable
        isSearchable={false}
        value={providerType}
      />
    </div>
  )
}

export default ProviderTypes
